import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import {
  DayHeader,
  Day,
  CalendarHeader,
  CalendarGrid,
  CalendarTitle,
} from '../styles';

const CalendarComponent = ({availableDates, occupiedDates, setSelected}) => {

  const [selectedDates, setSelectedDates] = useState([]);
  const [calendarDays, setCalendarDays] = useState([]);

  const weekdays = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'];
  
  useEffect(() => {
    const mesesEmPortugues = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const handleDateClick = (date) => {
      // Verifica se a data é uma das disponíveis antes de permitir a seleção
      if (availableDates.includes(date)) {
        // Define a data selecionada como a única, removendo qualquer seleção anterior
        setSelectedDates([date]);
        setSelected(date);
      }
    };
  
    const renderCalendar = () => {
      const today = dayjs();

      const startDate = today.startOf('day');
      const endDate = today.add(6, 'day').endOf('day');
      const calendarDays = [];

      let currentDay = startDate;
      let currentMonth = '';
      let monthDays = [];
      let monthNames = new Set();

      while (currentDay.isBefore(endDate)) {
        const monthIndex = currentDay.month();
        const year = currentDay.year();
        const month = `${mesesEmPortugues[monthIndex]} ${year}`;
  
        if (month !== currentMonth && !monthNames.has(month)) {
          if (monthDays.length > 0) {
            calendarDays.push(
              <div key={`month-${currentMonth}`}>
                <CalendarHeader>{currentMonth}</CalendarHeader>
                <CalendarGrid>{monthDays}</CalendarGrid>
              </div>
            );
            monthDays = [];
          }
          monthNames.add(month);
          currentMonth = month;
  
          const dayOfWeek = currentDay.day();
          const emptyDaysCount = (dayOfWeek === 0 ? 6 : dayOfWeek - 1);
  
          for (let i = 0; i < emptyDaysCount; i++) {
            monthDays.push(<Day key={`empty-${currentMonth}-${i}`} style={{ visibility: 'hidden' }} />);
          }
        }
  
        const dateStr = currentDay.format('YYYY-MM-DD');
        const isAvailable = availableDates.includes(dateStr);
        const isOccupied = occupiedDates.includes(dateStr);
        const isSelected = selectedDates.includes(dateStr);
  
        monthDays.push(
          <Day
            key={dateStr}
            $available={isAvailable}
            $occupied={isOccupied}
            selected={isSelected}
            onClick={isAvailable ? () => handleDateClick(dateStr) : undefined} // Habilita a seleção apenas se disponível
            style={{
              backgroundColor: isOccupied ? 'red' : (isAvailable ? '#92e37c' : 'transparent'),
              cursor: isAvailable ? 'pointer' : 'not-allowed', // Altera o cursor dependendo da disponibilidade
            }}
          >
            {currentDay.date()}
          </Day>
        );
  
        currentDay = currentDay.add(1, 'day');
      }
  
      if (monthDays.length > 0) {
        calendarDays.push(
          <div key={`month-${currentMonth}`}>
            <CalendarHeader>{currentMonth}</CalendarHeader>
            <CalendarGrid>{monthDays}</CalendarGrid>
          </div>
        );
      }
  
      setCalendarDays(calendarDays);
    };

    renderCalendar();
  }, [availableDates, occupiedDates, selectedDates, setSelected]);

  return (
    <div>
      <CalendarTitle>Calendário</CalendarTitle>
      <DayHeader key="weekday-header">
        {weekdays.map((day) => (
          <Day $isHeader key={day}>
            <strong>{day}</strong>
          </Day>
        ))}
      </DayHeader>
      {calendarDays}
    </div>
  );
};

export default CalendarComponent;
